import React from 'react';

const Fun = () => {
  return (
    <div>
    <p>Not Yet implemented</p>
    </div>
  );
};

export default Fun;
